<template>
	<section>
		<h1 v-translate class="is-size-1">User templates</h1>
		<div class="columns">
			<div class="column is-half is-mobile">
				<div v-if="checkedRows.length !== 0" class="buttons">
					<b-button type="is-danger is-outlined" icon-left="delete" @click="confirmDelete">
						<translate>Delete</translate>
					</b-button>
					<span class="pb-1">
						<translate
							:translate-n="checkedRows.length"
							:translate-params="{ total: checkedRows.length }"
							translate-plural="%{total} selected"
						>
							%{total} selected</translate
						>
					</span>
				</div>
			</div>
			<div class="column is-half is-mobile">
				<div class="buttons is-right">
					<b-button
						v-if="access.scopes.includes('user:write')"
						icon-left="plus" type="is-primary" tag="router-link" to="/template">
						<translate>New template</translate>
					</b-button>
				</div>
			</div>
		</div>
		<b-table
			ref="templateTable"
			checkable
			striped
			hoverable
			:data="data"
			:loading="loading"
			:checked-rows.sync="checkedRows"
		>
			<b-table-column field="name" :label="$gettext('Name')">
				<template #default="props">
					<router-link :to="`/template/${props.row._id}`" tag="span" class="is-clickable">
						{{ props.row.name }}
					</router-link>
				</template>
			</b-table-column>
		</b-table>
	</section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { errorToast, successToast } from '@moveup/app-core/mixins';

export default {
	mixins: [errorToast, successToast],
	data() {
		return {
			data: [],
			checkedRows: [],
			loading: false,
		};
	},
	computed: {
		...mapState('auth', ['access']),
	},
	mounted() {
		this.loadAsyncData();
	},
	methods: {
		...mapActions('app', ['getTemplates', 'deleteTemplates']),
		loadAsyncData() {
			this.checkedRows = [];
			this.loading = true;

			this.getTemplates()
				.then(data => {
					this.data = data.results;
					this.loading = false;
				})
				.catch(err => {
					this.data = [];
					this.loading = false;
					this.errorToast(err);
				});
		},
		confirmDelete() {
			const total = this.checkedRows.length;
			const translated = this.$ngettext(
				'Are you sure you want to delete this template? This action cannot be undone.',
				'Are you sure you want to delete these %{total} templates? This action cannot be undone.',
				total,
			);
			const message = this.$gettextInterpolate(translated, { total });
			this.$buefy.dialog.confirm({
				title: this.$gettext('Sure?'),
				message,
				confirmText: this.$gettext('Delete template'),
				type: 'is-danger',
				hasIcon: true,
				onConfirm: this.deleteSelected,
				focusOn: 'cancel',
			});
		},
		deleteSelected() {
			const ids = this.checkedRows.map(r => r._id);
			this.deleteTemplates(ids).then(result => {
				const total = result.deletedCount;
				const translated = this.$ngettext('%{total} template deleted.', '%{total} templates deleted.', total);
				const message = this.$gettextInterpolate(translated, { total });
				this.successToast(message);
				this.loadAsyncData();
			});
		},
	},
};
</script>
